interface ProjectStatusBadgeProps {
  status: string;
}

const config: Record<string, { badge: string; label: string }> = {
  planejado: { badge: "bg-secondary-100 text-secondary-700", label: "Planejado" },
  "em campo": { badge: "bg-primary-100 text-primary-700", label: "Em Campo" },
  "em revisao": { badge: "bg-warning-100 text-warning-700", label: "Em Revisão" },
  "em revisão": { badge: "bg-warning-100 text-warning-700", label: "Em Revisão" },
  concluido: { badge: "bg-accent-100 text-accent-700", label: "Concluído" },
  homologado: { badge: "bg-primary-50 text-primary-600", label: "Homologado" },
  arquivado: { badge: "bg-background-100 text-foreground-500", label: "Arquivado" },
  bloqueado: { badge: "bg-danger-100 text-danger-700", label: "Bloqueado" },
};

export default function ProjectStatusBadge({ status }: ProjectStatusBadgeProps) {
  const cfg = config[status] || { badge: "bg-background-100 text-foreground-500", label: status };
  return (
    <span className={`badge ${cfg.badge}`}>{cfg.label}</span>
  );
}